module.exports = __webpack_public_path__ + "static/media/bigcat.5f527558.gif";